'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.invalidActionWarning = invalidActionWarning;
exports.validAction = validAction;
exports.default = rootReducerInitializer;

var _redux = require('redux');

var _fluxStandardAction = require('flux-standard-action');

var production = process.env.NODE_ENV === 'production';

function invalidActionWarning(action) {
  return 'Action type ' + action.type + ' is not FSA compliant';
}

function validAction(action) {
  return (0, _fluxStandardAction.isFSA)(action) && (!(0, _fluxStandardAction.isError)(action) || action.payload instanceof Error);
}

function rootReducerInitializer(reducers) {
  var resetActionTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var combinedReducers = (0, _redux.combineReducers)(reducers);
  var appReducer = production ? combinedReducers : function appReducer(state, action) {
    // eslint-disable-next-line no-console
    if (!validAction(action)) console.warn(invalidActionWarning(action), action);
    return combinedReducers(state, action);
  };
  return function rootReducer(state, action) {
    if (resetActionTypes.length && resetActionTypes.includes(action.type)) {
      return appReducer(undefined, action);
    }

    return appReducer(state, action);
  };
}